export default {
  title: "Dotazník cvičení",
  message: "Informace, které poskytnete, pomohou přizpůsobit toto cvičení vaší situaci.",
  selectPlaceholder: "— Vyberte —",
  buttons: {
    submit: "Začít cvičení",
    cancel: "Zrušit",
    close: "Zavřít",
    edit: "Upravit dotazník",
    view: "Zobrazit dotazník",
  },
  success: "Vaše odpovědi byly zaznamenány.",
  errors: {
    loadFailed: "Nepodařilo se načíst formulář",
    submitFailed: "Nepodařilo se odeslat formulář",
  },
};
